export default __webpack_public_path__ + "3b57f13e41ef8f9912b85b37d92138bb.svg";